SelectMemberView = require 'app/scripts/views/member/select-member-view'
{ featureFlagClient } = require '@trello/feature-flag-client'

useNewSelect = -> featureFlagClient.get('remarkable.new-select-member', false)

module.exports = class SelectMemberOnCardView extends SelectMemberView
  #extra option: card
  initialize: ->
    @listenTo @options.card, 'change:idMembers', @renderActive

  renderActive: ->
    if useNewSelect()
      @$el.toggleClass('active', @model.id in @options.card.get('idMembers'))
    else
      @$('.js-member-item').toggleClass('active', @model.id in @options.card.get('idMembers'))

  render: ->
    super
    @renderActive()

    @
